import { AutoMap } from "@automapper/classes"

export class PlanningConfigurationDTO {
    @AutoMap()
    subContractingLab!: number
    @AutoMap()
    adresseDepart!: string
    @AutoMap()
    longitudeDepart!: number
    @AutoMap()
    latitudeDepart!: number
    @AutoMap()
    adresseArrivee!: string
    @AutoMap()
    longitudeArrivee!: number
    @AutoMap()
    latitudeArrivee!: number
    @AutoMap()
    heureDebutJournee!: string
    @AutoMap()
    amplitudeHoraireMaximale!: number
    @AutoMap()
    heurePauseMinimale!: string
    @AutoMap()
    dureePause!: number
    @AutoMap()
    couleurTrajetGoogleMaps!: string
}